import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { EmployerService } from './employer.service';
import { ErrorHandlerService } from './error-handler.service';
import { AdapterTypeEnum } from '../enums/adapter-type-enum';
import { EmployerDto, ExaAdapterV2Dto, ExaAdapterRestService } from '../api/exa';
import { AuthService } from './auth.service';
import { NGXLogger } from 'ngx-logger';
import { ExaGrant } from '../model/exa-grant';

@Injectable({
  providedIn: 'root',
})
export class ExaAdapterService {
  private employerDto: EmployerDto = null;

  private adapters: ExaAdapterV2Dto[] = [];
  private adapters$ = new BehaviorSubject<ExaAdapterV2Dto[]>([]);

  constructor(
    private access: AuthService,
    private employerService: EmployerService,
    private adapterRest: ExaAdapterRestService,
    private errorHandler: ErrorHandlerService,
    private log: NGXLogger
  ) {
    this.employerService.onSelectEmployer().subscribe((employer) => {
      this.employerDto = employer;

      if (this.employerDto) {
        this.reloadAdapters();
      } else {
        this.adapters = [];
        this.adapters$.next(this.adapters);
      }
    });

    this.log.debug('Construct');
  }

  reloadAdapters() {
    this.adapters = [];
    if (this.employerDto && this.access.hasGrantOwner(ExaGrant.READ_ADAPTER, this.employerDto.id)) {
      this.adapterRest.getAdaptersUsingPOST(this.employerDto.username, { size: 200 }).subscribe(
        (adapters) => {
          this.adapters = adapters.content;
          this.adapters$.next(this.adapters);
        },
        (err) => {
          this.adapters = [];
          this.adapters$.next(this.adapters);
          this.errorHandler.handleHttpError(err);
        }
      );
    } else {
      this.adapters$.next(this.adapters);
    }
  }

  onGetAdapters(): Observable<ExaAdapterV2Dto[]> {
    return this.adapters$;
  }

  getAdapterById(adapterId: number) {
    if (adapterId) {
      for (const adapter of this.adapters) {
        if (adapter.id == adapterId) {
          return adapter;
        }
      }
    }
    return null;
  }

  getAdapterByType(type: AdapterTypeEnum) {
    let adapterList = [];
    if (type) {
      for (const adapter of this.adapters) {
        if (adapter.type == type) {
          adapterList.push(adapter);
        }
      }
    }
    return adapterList;
  }

  getFormattedNameById(adapterId: number) {
    if (adapterId) {
      const adapter: ExaAdapterV2Dto = this.getAdapterById(adapterId);
      return adapter.serial;
    }
    return '';
  }

  getFormattedName(adapter: ExaAdapterV2Dto) {
    if (adapter) {
      return adapter.serial;
    }
    return '';
  }
}
